<template lang="pug">
  n-dialog(
    v-model='dialog'
    :width='700'
  )
    v-card(style="border-radius: 12px;").pa-3.px-sm-7 
      v-row(justify="center" no-gutters)
        h3.font-weight-power-ball {{ $t('order-list') }}
        v-icon(@click="close" style="position:absolute; right:5px;") mdi-close-box
      v-divider
      v-row.pt-3
        v-col(cols=12)
          v-row(no-gutters)
            v-col(style="max-width:min(5vw, 50px);")
              .single-line 
                b.fontOrderStake No.
            .whiteballWidthColumn
              .single-line
                b.fontOrderStake White ball
            .powerballWidthColumn
              .single-line
                b.fontOrderStake Powerball
            .powerPlayWidthColumn
              .single-line
                b.fontOrderStake Power play
            v-col
              .single-line
                b.fontOrderStake {{ $t('unit.credit') }}
            v-col(cols="auto")
        v-col(cols=12).px-5
          v-row.cardOrderList(align="center")
            v-col(cols=12 v-if="items.length === 0" align="center")
              h2.font-weight-power-ball {{ $t('message.please-select-power-ball') }}
            v-col(cols=12 v-else).py-0.px-1.px-sm-3
              v-row(
                v-for="(item,i) in items"
                :key="i"
                align="center"
                no-gutters
              )
                v-col(style="max-width:min(5vw, 50px);") 
                  b.fontOrderStake {{ i+1 }}
                v-col.winnumberColumn
                  winnumber(
                    :small="$vuetify.breakpoint.width < 641"
                    :win-number-array="item.winNumberArray"
                  )
                v-col(cols="auto")
                  v-img(:src="require('@/assets/powerball/tropy.svg')" max-width="30").iconTropy
                v-col(cols=1).px-1
                  v-checkbox(
                    v-model="item.powerPlay"
                    @change="setSumPrice"
                  )
                v-col(cols=2 align="center")
                  .fontOrderStake {{ item.powerPlay ? parseFloat(priceStake) +  parseFloat(priceStakePowerPlay) : priceStake | currency }}
                v-col(cols="auto").px-sm-2
                  n2-btn(
                    :block="false"
                    style="min-width:5px; padding:5px;"
                    color="grey"
                    @click="clickBtnRemove(i)"
                  ).buttonTrash
                    v-img(
                      max-width="20"
                      :src="require('@/assets/anything/trash.png')"
                    ).iconTrash
      v-row(align="center")
        v-col(cols=12 sm="auto").px-0
          ul
            li.listDescribe {{ $t('power-ball.des-message-1') }}
            li.listDescribe {{ $t('power-ball.des-message-2') }}
            //- li.listDescribe {{ $t('power-ball.des-message-3') }}
        v-col(cols=12 sm="auto" align="center").px-10.py-1
          h4.font-weight-power-ball {{ $t('power-ball.sum-price',{ value: sumPrice }) }}
        v-col(cols=12 align="center")
          n2-btn(
            color="var(--btn-cancel-powerball-v2)"
            :block="false"
            style="min-width:100px;"
            @click="close"
          ).mr-1
            h3.font-weight-power-ball {{ $t('button.cancel') }}
          n2-btn(
            color="var(--btn-activate-whiteball-v2)"
            :block="false"
            style="min-width:100px;"
            @click="submit"
          ) 
            h3.font-weight-power-ball {{ $t('button.buy') }}

          
</template>
<script>
import Winnumber from './Winnumber'
export default {
  components: {
    Winnumber
  },
  props: {
    setSumPrice: {
      type: Function,
      default: () => {}
    },
    priceStake: {
      type: String,
      default: null 
    },
    priceStakePowerPlay: {
      type: [String,Number],
      default: null 
    },
    items: {
      type: Array,
      default: () => []
    },
    sumPrice: {
      type: [String,Number],
      default:null
    },
    clickBtnRemove: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    dialog:false
  }),
  methods: {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    submit () {
      this.$emit('submit')
      this.close()
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 410px) {
  .whiteballWidthColumn {
    min-width: 0px;
    width: min(25vw ,130px) ;
  } 
  .powerballWidthColumn {
    min-width: 0px ;
    width: min(16vw ,65px) ; 
  }
  .powerPlayWidthColumn { 
    min-width: 0px ;
    width:  17vw;
  }
}
@media only screen and (min-width: 411px) and (max-width: 640px) {
  .whiteballWidthColumn {
    min-width: 0px;
    width: min(25vw ,130px);
  } 
  .powerballWidthColumn {
    min-width: 0px;
    width: min(20vw ,180px); 
  }
  .powerPlayWidthColumn { 
    min-width: 0px ;
    width:  min(17vw ,110px);
  }
}

@media only screen and (min-width: 640px) {
  .winnumberColumn{
    min-width: 300px;
  }
  .whiteballWidthColumn {
    min-width: min(35vw ,240px);
  }
  .powerballWidthColumn {
    min-width: 75px;
    width: 90px;
    padding:0;
  }
  .powerPlayWidthColumn {
    min-width: auto;
    width: 135px;
  }
}
.single-line {
  max-width: 95%;
  white-space: nowrap;
  overflow: hidden; 
}
.fontOrderStake {
  font-size: min(2.5vw, 16px);
}
.listDescribe {
  color:red;
  font-size: min(2.5vw, 10px);
}
.cardOrderList {
  background: var(--card-order-list-v2); 
  min-height: 150px; 
  max-height: 150px;
  border-radius: 8px;
  overflow-y: scroll;
}

.buttonTrash {
  width: min(6vw,30px);
  height: min(6vw,30px) !important;
}
.iconTropy{
  width: min(5vw,30px);
  height: min(5vw,30px);
}
.iconTrash {
  width: min(4vw,20px);
  height: min(4vw,20px);
}

</style>